import {
    handoutMaterialsURL,
    uploadHandoutMaterialURL,
    deleteHandoutMaterialURL,
} from "../../apiEndPoints"
import {
    setHandoutMaterials,
    setHandoutLoading,
    setHandoutError,
    addHandoutMaterial,
    removeHandoutMaterial,
} from "./handoutMaterialsSlice"
import { logTransaction } from "../appActions"
import { axiosGet, axiosPost, axiosDelete } from "../../utilities/axiosRequest"

export function getHandoutMaterials(data, success, failure) {
    return function (dispatch, getState) {
        dispatch(setHandoutLoading(true))
        const program = getState().user.program
        let url =
            handoutMaterialsURL +
            `/get?clinicId=${data?.clinicId}&organizationId=${data?.organizationId}`
        if (program?.id) {
            // url += `&programId=${program.id}`
        }
        axiosGet(url)
            .then(response => {
                if (
                    response?.data?.responseData !== null &&
                    response?.data?.responseData !== undefined
                ) {
                    dispatch(setHandoutMaterials(response.data.responseData))
                    dispatch(setHandoutLoading(false))
                    dispatch(
                        logTransaction("Fetch Handout Materials", response)
                    )
                    success && success(response.data.responseData)
                } else {
                    dispatch(setHandoutMaterials([]))
                    dispatch(setHandoutLoading(false))
                    dispatch(
                        logTransaction(
                            "Fetch Handout Materials Failed",
                            response
                        )
                    )
                    failure && failure("No data found")
                }
            })
            .catch(err => {
                dispatch(setHandoutMaterials([]))
                dispatch(setHandoutLoading(false))
                dispatch(
                    setHandoutError(err?.message || "Failed to fetch materials")
                )
                dispatch(logTransaction("Fetch Handout Materials Failed", err))
                failure && failure(err?.message || "Failed to fetch materials")
            })
    }
}

export function uploadHandoutMaterial(data, success, failure) {
    return function (dispatch, getState) {
        dispatch(setHandoutLoading(true))
        const url = uploadHandoutMaterialURL
        axiosPost(url, data)
            .then(response => {
                if (
                    response?.data?.statusCD === 200 ||
                    response?.data?.responseData
                ) {
                    dispatch(setHandoutLoading(false))
                    dispatch(
                        logTransaction("Upload Handout Material", response)
                    )
                    success && success(response.data.responseData)
                } else {
                    dispatch(setHandoutLoading(false))
                    dispatch(
                        logTransaction(
                            "Upload Handout Material Failed",
                            response
                        )
                    )
                    failure &&
                        failure(response?.data?.statusMSG || "Upload failed")
                }
            })
            .catch(err => {
                dispatch(setHandoutLoading(false))
                dispatch(
                    setHandoutError(err?.message || "Failed to upload material")
                )
                dispatch(logTransaction("Upload Handout Material Failed", err))
                failure && failure(err?.message || "Failed to upload material")
            })
    }
}

export function deleteHandoutMaterial(id, success, failure) {
    return function (dispatch, getState) {
        dispatch(setHandoutLoading(true))
        const url = `${deleteHandoutMaterialURL}/${id}`
        axiosDelete(url)
            .then(response => {
                if (
                    response?.data?.statusCD === 200 ||
                    response?.status === 200
                ) {
                    dispatch(removeHandoutMaterial(id))
                    dispatch(setHandoutLoading(false))
                    dispatch(
                        logTransaction("Delete Handout Material", response)
                    )
                    success && success()
                } else {
                    dispatch(setHandoutLoading(false))
                    dispatch(
                        logTransaction(
                            "Delete Handout Material Failed",
                            response
                        )
                    )
                    failure &&
                        failure(response?.data?.statusMSG || "Delete failed")
                }
            })
            .catch(err => {
                dispatch(setHandoutLoading(false))
                dispatch(
                    setHandoutError(err?.message || "Failed to delete material")
                )
                dispatch(logTransaction("Delete Handout Material Failed", err))
                failure && failure(err?.message || "Failed to delete material")
            })
    }
}

// Fetch patient's assigned handout materials
export function getPatientHandouts(patientId, success, failure) {
    return function (dispatch) {
        const url = `${handoutMaterialsURL}/getPatientHandouts/${patientId}`
        axiosGet(url)
            .then(response => {
                if (
                    response?.data?.responseData !== null &&
                    response?.data?.responseData !== undefined
                ) {
                    dispatch(logTransaction("Fetch Patient Handouts", response))
                    success && success(response.data.responseData)
                } else {
                    dispatch(
                        logTransaction(
                            "Fetch Patient Handouts - No Data",
                            response
                        )
                    )
                    success && success([])
                }
            })
            .catch(err => {
                dispatch(logTransaction("Fetch Patient Handouts Failed", err))
                failure &&
                    failure(err?.message || "Failed to fetch patient handouts")
            })
    }
}

// Assign handout material to patient
export function assignHandoutToPatient(
    handoutMaterialId,
    patientId,
    success,
    failure
) {
    return function (dispatch) {
        const url = `${handoutMaterialsURL}/assignToPatient?handoutMaterialId=${handoutMaterialId}&patientId=${patientId}`
        axiosPost(url)
            .then(response => {
                if (
                    response?.data?.statusCD === 200 ||
                    response?.status === 200
                ) {
                    dispatch(
                        logTransaction("Assign Handout to Patient", response)
                    )
                    success && success(response.data.responseData)
                } else {
                    dispatch(
                        logTransaction(
                            "Assign Handout to Patient Failed",
                            response
                        )
                    )
                    failure &&
                        failure(
                            response?.data?.statusMSG || "Assignment failed"
                        )
                }
            })
            .catch(err => {
                dispatch(
                    logTransaction("Assign Handout to Patient Failed", err)
                )
                failure && failure(err?.message || "Failed to assign handout")
            })
    }
}

// Unassign handout material from patient
export function unassignHandoutFromPatient(
    handoutMaterialId,
    patientId,
    success,
    failure
) {
    return function (dispatch) {
        const url = `${handoutMaterialsURL}/unAssignFromPatient?handoutMaterialId=${handoutMaterialId}&patientId=${patientId}`
        axiosDelete(url)
            .then(response => {
                if (
                    response?.data?.statusCD === 200 ||
                    response?.status === 200
                ) {
                    dispatch(
                        logTransaction(
                            "Unassign Handout from Patient",
                            response
                        )
                    )
                    success && success()
                } else {
                    dispatch(
                        logTransaction(
                            "Unassign Handout from Patient Failed",
                            response
                        )
                    )
                    failure &&
                        failure(
                            response?.data?.statusMSG || "Unassignment failed"
                        )
                }
            })
            .catch(err => {
                dispatch(
                    logTransaction("Unassign Handout from Patient Failed", err)
                )
                failure && failure(err?.message || "Failed to unassign handout")
            })
    }
}
